import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css, type CSSResult } from 'lit'

export const style: CSSResult = css`
  .csc-delivery-match-continue-button {
    display: flex;
    margin-top: ${csSpacing.spacing06};
    justify-content: flex-end;
  }

  cse-loader {
    --cse-loader-color: currentColor;
  }
`
